import useSWRImmutable from 'swr/immutable'
import { getPotteryVaultContract } from 'utils/contractHelpers'

export const usePotteryStatus = () => {
  const { data: potteryStatus } = useSWRImmutable('potteryLastStatus', async () => {
    const lastVaultAddress = '0x2498872c74286259A2f81a142119139a5899A02E' // await fetchLastVaultAddress()
    const potteryVaultContract = getPotteryVaultContract(lastVaultAddress)
    return potteryVaultContract.getStatus()
  })

  return potteryStatus
}
